<script setup lang="ts">
import { useTableDense } from "./density.ts";

const dense = useTableDense();
</script>

<template>
  <th
    :class="[
      'text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0',
      dense ? 'h-9 px-1.5' : 'h-12 px-4',
    ]"
  >
    <slot />
  </th>
</template>
